import { getRoute } from '@utils/route';
import { PersonalAccidentQuoteDetailsPageParams } from '@components/PersonalAccidentQuoteDetailsRoute/route';

export type PersonalAccidentQuoteBuyNewPageParams = PersonalAccidentQuoteDetailsPageParams;

export const PERSONAL_ACCIDENT_QUOTE_BUY_ROUTE_URL = '/personal-accident-insurance-quote-buy/*';
export const PERSONAL_ACCIDENT_QUOTE_BUY_NEW_PAGE_URL = '/personal-accident-insurance-quote-buy';
export const PERSONAL_ACCIDENT_QUOTE_BUY_EDIT_PAGE_URL = '/personal-accident-insurance-quote-buy/:orderNumber/edit';
export const PERSONAL_ACCIDENT_QUOTE_BUY_REVIEW_PAGE_URL = '/personal-accident-insurance-quote-buy/:orderNumber/review';
export const PERSONAL_ACCIDENT_QUOTE_BUY_CUSTOM_PAGE_URL = '/personal-accident-insurance-quote-buy/:orderNumber/custom';

type RouteParams = {
  orderNumber: string;
}

export const routePersonalAccidentQuoteBuyNewPage = (searchParams: PersonalAccidentQuoteBuyNewPageParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_BUY_NEW_PAGE_URL, { searchParams });
export const routePersonalAccidentQuoteBuyEditPage = (routeParams: RouteParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_BUY_EDIT_PAGE_URL, { routeParams });
export const routePersonalAccidentQuoteBuyReviewPage = (routeParams: RouteParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_BUY_REVIEW_PAGE_URL, { routeParams });
export const routePersonalAccidentQuoteBuyCustomPage = (routeParams: RouteParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_BUY_CUSTOM_PAGE_URL, { routeParams });
